<template>
  <el-dialog
    :title="`CHI TIẾT`"
    :visible.sync="dialogBookingStatusVisible"
    width="80%"
    :close-on-click-modal="false"
  >
    <div>
      <search-comp @onSearch="onSearchBS" @onReset="onResetBS">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-4">
                <div class="das-form-input">
                  <div class="label">
                    {{ 'Ngày' }}
                  </div>
                  <div>
                    <CalendarSelect
                      v-model="searchParams.date"
                      style="display: block; width: 100%"
                      mode="date"
                    />
                  </div>
                </div>
              </div>
              <div class="das-form-col col-4">
                <div class="das-form-input">
                  <div class="label">
                    {{ 'Dịch vụ đặc biệt' }}
                  </div>
                  <div>
                    <select-with-search-table
                      style="width: auto; flex-grow: 1"
                      index-field="id"
                      :search-fields="['id', 'code', 'desc']"
                      :selected-index-field-value="
                        searchParams.specialServiceList
                      "
                      :value="searchParams.specialServiceList"
                      :rows="specSvcRows"
                      :columns="specSvcCols"
                      :dropdown-width="600"
                      :is-remove-btn="true"
                      :multiple="true"
                      @selectionChanged="onSelectSpecSvc"
                    >
                      <template v-slot:value="{ selectedValue: selectedData }">
                        <span v-for="data in selectedData" :key="data.code"
                          >{{ data?.code }},
                        </span>
                      </template>
                    </select-with-search-table>
                  </div>
                </div>
              </div>
              <div class="das-form-col col-4">
                <div class="das-form-input">
                  <div class="label">
                    {{ 'Hạng phòng' }}
                  </div>
                  <div>
                    <select-with-search-table
                      style="width: auto; flex-grow: 1"
                      index-field="id"
                      :search-fields="['id', 'code', 'name']"
                      :selected-index-field-value="searchParams.roomTypeId"
                      :value="searchParams.roomTypeId"
                      :rows="roomTypeRows"
                      :columns="roomTypeCols"
                      :dropdown-width="600"
                      :is-remove-btn="true"
                      @selectionChanged="onSelectRoomType"
                    >
                      <template v-slot:value="{ selectedValue: selectedData }">
                        <div>
                          <span>
                            {{
                              `${selectedData?.code || ''} - ${
                                selectedData?.name || ''
                              }`
                            }}
                          </span>
                        </div>
                      </template>
                    </select-with-search-table>
                  </div>
                </div>
              </div>
            </div>

            <div class="das-form-row">
              <div class="das-form-col col-4">
                <div class="das-form-input">
                  <div class="label">
                    {{ 'Thông tin' }}
                  </div>
                  <div>
                    <input v-model="searchParams.info" type="text" />
                  </div>
                </div>
              </div>
              <div class="das-form-col col-4">
                <div class="das-form-input">
                  <div class="label" style="visibility: hidden">
                    {{ '' }}
                  </div>
                  <div
                    style="
                      background: #f0f0f5;
                      padding: 0 8px;
                      margin: 0;
                      height: 32px;
                      display: flex;
                      align-items: center;
                      border-radius: 5px;
                      justify-content: space-between;
                    "
                  >
                    <div class="checkbox-wrap">
                      <input
                        id="isInternal"
                        v-model="searchParams.isInternal"
                        type="checkbox"
                      />
                      <label
                        for="isInternal"
                        style="color: #606266; font-size: 14px"
                        >{{ 'Nội bộ' }}</label
                      >
                    </div>
                    <div class="checkbox-wrap">
                      <input
                        id="isFree"
                        v-model="searchParams.isFree"
                        type="checkbox"
                      />
                      <label
                        for="isFree"
                        style="color: #606266; font-size: 14px"
                        >{{ 'Miễn phí' }}</label
                      >
                    </div>
                    <div class="checkbox-wrap">
                      <input
                        id="isOneDayBooking"
                        v-model="searchParams.isOneDayBooking"
                        type="checkbox"
                      />
                      <label
                        for="isOneDayBooking"
                        style="color: #606266; font-size: 14px"
                        >{{ 'Phòng ở trong ngày' }}</label
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </search-comp>
    </div>

    <div>
      <tab v-model="searchParams.tab" :tab-list="tabList" />

      <div v-if="searchParams.tab === 1" class="tab-content">
        <div v-loading="loading" class="grid-scroll">
          <GridVx
            ref="infoGrid"
            style="height: calc(5 * 34px + 40px + 10px)"
            class="agGrid"
            :columns="folioCols"
            :rows="folioRows"
            @selectionChanged="
              value => {
                selectedRows = value
              }
            "
          />
        </div>

        <div class="grid-bottom">
          <GridPaging
            target="agGrid"
            :total-size="searchParams.totalPage"
            :page-num="searchParams.currentPage"
            @pageChanged="onPageChanged"
            @onPageSizeChange="onPageSizeChange"
          />
        </div>
      </div>

      <div v-if="searchParams.tab === 2" class="tab-content">
        <div v-loading="loading" class="grid-scroll">
          <GridVx
            ref="infoGrid"
            style="height: calc(5 * 34px + 40px + 10px)"
            class="agGrid"
            :columns="folioCols"
            :rows="[]"
            @selectionChanged="
              value => {
                selectedRows = value
              }
            "
          />
        </div>
      </div>
      <div v-if="searchParams.tab === 3" class="tab-content">
        <div v-loading="loading" class="grid-scroll">
          <GridVx
            ref="infoGrid"
            style="height: calc(5 * 34px + 40px + 10px)"
            class="agGrid"
            :columns="folioCols"
            :rows="[]"
            @selectionChanged="
              value => {
                selectedRows = value
              }
            "
          />
        </div>
      </div>
      <div v-if="searchParams.tab === 4" class="tab-content">
        <div v-loading="loading" class="grid-scroll">
          <GridVx
            ref="infoGrid"
            style="height: calc(5 * 34px + 40px + 10px)"
            class="agGrid"
            :columns="folioCols"
            :rows="[]"
            @selectionChanged="
              value => {
                selectedRows = value
              }
            "
          />
        </div>
      </div>
      <div v-if="searchParams.tab === 5" class="tab-content">
        <div v-loading="loading" class="grid-scroll">
          <GridVx
            ref="infoGrid"
            style="height: calc(5 * 34px + 40px + 10px)"
            class="agGrid"
            :columns="folioCols"
            :rows="[]"
            @selectionChanged="
              value => {
                selectedRows = value
              }
            "
          />
        </div>
      </div>
      <div v-if="searchParams.tab === 6" class="tab-content">
        <div v-loading="loading" class="grid-scroll">
          <GridVx
            ref="infoGrid"
            style="height: calc(5 * 34px + 40px + 10px)"
            class="agGrid"
            :columns="folioCols"
            :rows="[]"
            @selectionChanged="
              value => {
                selectedRows = value
              }
            "
          />
        </div>
      </div>
    </div>

    <span
      slot="footer"
      class="dialog-footer"
      style="display: flex; justify-content: flex-end"
    >
      <div
        class="button-containers"
        style="width: 60%; display: flex; justify-content: flex-end"
      >
        <button
          class="btn primary small outline"
          @click="dialogBookingStatusVisible = false"
        >
          {{ 'Đóng' }}
        </button>
        <button
          class="btn primary small"
          :disabled="selectedRows.length !== 1"
          @click="onOpenUpdateBookingRoom"
        >
          {{ 'Sửa đặt phòng' }}
        </button>
        <button class="btn primary small">
          {{ 'Xuất Excel' }}
        </button>
      </div>
    </span>

    <!-- Sua dat phong dialog -->
    <el-dialog
      :visible.sync="isBookingRoomDialogOpened"
      title="Thông tin đặt phòng"
      width="80%"
      append-to-body
      @close="onCloseBookingRoomDialog"
    >
      <BookingRoomForm
        ref="BookingRoomForm"
        :action="bookingRoomFormAction"
        :record-data="bookingRoomFormData"
      ></BookingRoomForm>
      <span
        slot="footer"
        class="dialog-footer"
        style="display: flex; gap: 10px; justify-content: flex-end"
      >
        <button
          v-if="bookingRoomFormAction == 'create'"
          class="btn primary small"
          @click="onCreateBookingRoom"
        >
          Thêm
        </button>
        <button
          v-if="bookingRoomFormAction == 'edit'"
          class="btn primary small"
          @click="onUpdateBookingRoom"
        >
          Cập nhật
        </button>
        <button
          class="btn primary small outline"
          @click="onCloseBookingRoomDialog"
        >
          Đóng
        </button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
/* eslint-disable */
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import Tab from '@/components/Tab'
import BookingRoomForm from '@/components/resources/booking/BookingRoomForm'

import { CellRenderCheckboxReadonly } from '@/utils/cellRenders'
import { callGetRoomLevel, callGetSpecialService } from '../utils/commonApiCall'
import { getBookingStatus } from '@/api/reception/reception'
import {
  getBookingRoom,
  updateBookingRoom
} from '@/api/booking_service/booking'
import { notifyError, notifySuccess } from '@/utils/toast'

export default {
  components: {
    BookingRoomForm,
    CalendarSelect,
    Tab,
    CellRenderCheckboxReadonly
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    bookStatusSearch: {
      type: Object
    }
  },
  data: function () {
    return {
      // dialog
      dialogBookingStatusVisible: this.value,

      // tab
      tabList: [
        { label: 'Folio', value: 1 },
        { label: 'Đoàn (Chưa nhận phòng)', value: 2 },
        { label: 'Seri Booking', value: 3 },
        { label: 'Allotment', value: 4 },
        { label: 'Phòng ngưng sử dụng', value: 5 },
        { label: 'Phòng không đảm bảo dịch vụ', value: 6 }
      ],

      // search params
      searchParams: {
        date: null,
        bookingStatus: [],
        roomTypeId: null,
        specialServiceList: null,
        isInternal: false,
        isFree: false,
        isOneDayBooking: false,
        info: null,
        tab: 1,
        pageSize: 10,
        totalPage: null,
        currentPage: 1
      },
      defaultSearchParams: {
        date: null,
        bookingStatus: [],
        roomTypeId: null,
        specialServiceList: null,
        isInternal: false,
        isFree: false,
        isOneDayBooking: false,
        info: null,
        tab: 1,
        totalPage: null,
        pageSize: 10,
        currentPage: 1
      },

      // multi select
      bsOptions: [
        {
          value: 1,
          label: 'Definite'
        },
        {
          value: 2,
          label: 'Tentative'
        },
        {
          value: 3,
          label: 'Waiting'
        },
        {
          value: 4,
          label: 'Seri booking'
        }
      ],

      // select with search table
      roomTypeRows: [],
      roomTypeCols: [
        { headerName: 'ID', field: 'id', tooltipField: 'id' },
        { headerName: 'Mã', field: 'code', tooltipField: 'code' },
        {
          headerName: 'Tên',
          field: 'name',
          tooltipField: 'name'
        }
      ],
      specSvcRows: [],
      specSvcCols: [
        { headerName: 'ID', field: 'id', tooltipField: 'id' },
        { headerName: 'Mã', field: 'code', tooltipField: 'code' },
        {
          headerName: 'Mô tả',
          field: 'desc',
          tooltipField: 'desc'
        }
      ],

      // tab content

      // sua dat phong dialog
      isBookingRoomDialogOpened: false,
      bookingRoomFormAction: 'edit',
      bookingRoomFormData: null,

      loading: false,

      folioRows: [],
      folioCols: [
        { headerName: 'Trạng thái', field: 'status_nm' },
        { headerName: 'Số xác nhận', field: 'confirm_code' },
        { headerName: 'Mã đoàn', field: 'booking_code' },
        { headerName: 'Mã đặt phòng', field: 'room_booking_code' },
        {
          headerName: 'Tên khách',
          valueGetter: params =>
            `${params.data.last_name} ${params.data.first_name}`
        },
        { headerName: 'Công ty, đại lý du lịch', field: 'agent_nm' },
        { headerName: 'Hạng phòng', field: 'room_level_cd' },
        { headerName: 'Phòng', field: 'room_num' },
        { headerName: 'Ngày đến', field: 'arrive_date' },
        { headerName: 'Ngày đi', field: 'depart_date' },
        { headerName: 'Số lượng khách', field: 'num_of_guest' },
        { headerName: 'Trạng thái đặt', field: 'booking_status_nm' },
        { headerName: 'Giá phòng', field: 'room_price' },
        {
          headerName: 'Nội bộ',
          field: 'is_internal',
          cellClass: 'grid-cell-align-center',
          cellRenderer: 'CellRenderCheckboxReadonly'
        },
        {
          headerName: 'Miễn phí',
          field: 'is_free',
          cellClass: 'grid-cell-align-center',
          cellRenderer: 'CellRenderCheckboxReadonly'
        }
        // { headerName: 'Phòng ở trong ngày', field: '' }
      ],
      selectedRows: []
    }
  },

  watch: {
    value(nv, ov) {
      this.dialogBookingStatusVisible = nv
    },
    dialogBookingStatusVisible(nv, ov) {
      if (!nv) {
        this.$emit('input', nv)
      }
    },
    bookStatusSearch(nv, ov) {
      this.defaultSearchParams = Object.assign(
        { ...this.defaultSearchParams },
        nv
      )
      this.searchParams = { ...this.defaultSearchParams }
      this.onSearchBS()
    }
  },

  async mounted() {
    this.roomTypeRows = await callGetRoomLevel()
    this.specSvcRows = await callGetSpecialService()
  },

  methods: {
    // handle event
    onSearchBS() {
      this.fnGetBookingStatus()
    },
    onResetBS() {
      this.searchParams = { ...this.defaultSearchParams }
      this.fnGetBookingStatus()
    },

    onSelectRoomType(data) {
      this.searchParams.roomTypeId = data?.id || null
    },
    onSelectSpecSvc(data) {
      this.searchParams.specialServiceList =
        data?.map(item => item.id).join(',') || null
    },

    async onPageChanged(pageNum) {
      this.searchParams.currentPage = pageNum
      await this.fnGetBookingStatus()
    },
    async onPageSizeChange(pageSize) {
      this.searchParams.pageSize = pageSize
      this.searchParams.currentPage = 1
      await this.fnGetBookingStatus()
    },

    // handle api call
    fnGetBookingStatus() {
      this.loading = true
      getBookingStatus(this.searchParams)
        .then(res => {
          if (!res.is_error) {
            this.folioRows = res.data
            this.searchParams.totalPage = Math.ceil(
              res.total / this.searchParams.pageSize
            )
            // ?? get query value after queried ??
            this.searchParams.bookingStatus = res.status?.map(
              item => item.booking_status_id
            )
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    // sua dat phong dialog
    async onOpenUpdateBookingRoom() {
      const selectedRoom = this.selectedRows[0]
      if (selectedRoom?.sub_booking_group_id != null) {
        const bookingRoom = await getBookingRoom(
          selectedRoom?.sub_booking_group_id
        )
          .then(res => {
            return res.data
          })
          .catch(() => {
            this.$message({
              type: 'error',
              message: 'Đã có lỗi xảy ra'
            })
          })

        if (bookingRoom == null) {
          return
        }

        this.bookingRoomFormData = bookingRoom
        this.isBookingRoomDialogOpened = true
        this.bookingRoomFormAction = 'edit'
      }
    },
    async updateBookingRoom(id, payload) {
      await updateBookingRoom(id, payload)
        .then(res => {
          notifySuccess(res?.message)
          return true
        })
        .catch(err => {
          notifyError(err?.response?.data?.message)
          return false
        })
    },
    async onUpdateBookingRoom() {
      const payload = this.$refs.BookingRoomForm.dehydrateForm()

      if (this.bookingRoomFormData.id) {
        if (
          !(await this.updateBookingRoom(this.bookingRoomFormData.id, payload))
        ) {
          await this.fnGetBookingStatus()
          return
        }
      }

      Object.assign(
        this.formData.booking_room[this.bookingRoomTableIndex],
        payload
      )
      this.onCloseBookingRoomDialog()
      this.$refs.BookingFormRoomTable.$refs.bookingRoomTable.gridOptions.api.refreshCells(
        {
          force: true
        }
      )
    },
    onCloseBookingRoomDialog() {
      this.isBookingRoomDialogOpened = false
    }
  }
}
</script>
